<!-- 实名页 -->
<template>
  <div class='loginReal'>
    <div class="wrapReal">
      
      <div class="HseatReal"></div>
      <div class="inputFormReal">
        <div class="telDivReal">
          <span>姓名：</span>
          <input class="pswWidthReal" type="text" placeholder="请输入姓名" v-model="realname">
        </div>
        <div class="clearBoth"></div>
        <div class="telDivReal">
          <span>身份证号：</span>
          <input class="pswWidthReal" type="text" placeholder="请输入身份证号码" v-model="userIdCard">
        </div>
      <div class="HseatReal"></div>
</div>
      <div class="loginBtnReal" @click="sumbit">添加观影人</div>
    
    </div>
     
  </div>
</template>

<script>
 import * as api from '@/api'
 import { mapMutations } from 'vuex';
 import JmmToast from '@/components/JmmToast'
 
 let realnameRegular = /^[\u0391-\uFFE5]+$/;
  export default {
    name: 'login',
    data () {
      return {
       sign:'',
       token:'',
       realname:'',
       userIdCard:'',
       userId:'',
       goback:'',
       num:'',
      }
    },
    components: {
      JmmToast,
    },
    
    created() {
      this.merchantId = this.$route.query.merchantId;
      if(null != this.merchantId && undefined != this.merchantId && "merchantId" != this.merchantId){
        localStorage.setItem('cityMerchantId', this.merchantId);
      }
      this.token = this.$route.query.token;
      this.sign = this.$route.query.sign;
      this.userId = this.$route.query.userId;
      this.goback = this.$route.query.goback;
      this.num = this.$route.query.num;
    },
    computed: {
   
    },
    mounted: function () {
    },
    methods: {
        // 提交
        async sumbit(){
          let _this = this;
          if (_this.realname == '') {
             JmmToast('姓名不能为空')
             return
          }
          if (_this.userIdCard == '') {
             JmmToast('身份证号不能为空')
             return
          }
          if (!realnameRegular.test(_this.realname)) {
            JmmToast('姓名必须是汉字')
            return
          }
          //验证身份证
          let userIdCard = _this.userIdCard;
          if(this.validid.cnid(userIdCard)!=true){
            JmmToast('身份证错误')
            return
          }
          
          try{
            let testToken = 'lmojakdhkadocfaccfjocklccdfkhgoj';
            let testSign = 'dpbijiiiefibmadgopamipinnnpnphof';
            localStorage.setItem('reToken', _this.token==undefined?testToken: _this.token);
            let info = {
                realname: _this.realname,
                status: 1,
                userId: _this.userId,
                gender:1,
                userIdCard:_this.userIdCard,
                sign:_this.sign==undefined?testSign:_this.sign
            }
            const {code,data,message} = await api.user.watchUserAdd(info)
      
            if(code == '000000'){
              
              JmmToast('添加成功')
              let url = '';
              if (_this.goback == undefined) {
                url = '/contactlist.html';
              }else{
                url = _this.goback;
              }
              url += '#/?token='+_this.token+'&sign='+_this.sign;
              if(_this.num!=undefined){
                url = url+'&num='+_this.num;
              }
              console.log(url);
              window.location.href=url;
            }else{
              JmmToast(message)
              // HyrToast(submsg || msg)
            }
          }catch(err){
            console.log(err)
          }
        },
  
    },
   
  }
</script>

<style lang="stylus">
@import '../../assets/css/common.styl'
@import '../../assets/css/icon.css'
.wrapReal
   width 100%
   height 100%
  .headWrap
   height 88px
   line-height 88px
   font-size 36px
   color #262626
   display flex
   width calc(100% - 48px);
   margin 0 auto

   span
    flex 1
   span:nth-child(1) img
    width 22px
    height 38px
    vertical-align middle
   span:nth-child(2)
    text-align center
    
.HseatReal
  height 129px

.telDivReal
  width calc(100% - 150px)
  margin 15px auto
  height 80px
  border-bottom 1px solid #ddd
  display flex
  i 
    font-style normal
    margin-top 15px
   
  input 
    width calc(100% - 60px)
    height 66px
    font-size 28px
    
  span 
     display inline-block
     float left
     align-self center
     width 200px 
     font-size 28px

.loginBtnReal
  width calc(100% - 150px)
  height 90px
  line-height 90px
  background $background
  border-radius 45px
  font-size 34px
  text-align center
  color:$color
  cursor pointer
  position absolute
  left:0
  right 0
  bottom 40px
  margin auto
  

.agremment
  width calc(100% - 224px)  
  margin 32px auto
  font-size 24px
  span 
   cursor pointer
.clearBoth
  clear both  
.leftRouter
  float $floLeft
.rightRouter
  float $florRight    
.loginReal  
  background #fff 
</style>



// WEBPACK FOOTER //
// src/view/realname/index.vue